import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Badge } from '../components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Textarea } from '../components/ui/textarea';
import { 
  CreditCard, 
  ShoppingBag,
  Plus, 
  Search, 
  Filter,
  DollarSign,
  TrendingUp,
  TrendingDown,
  Calendar,
  Download,
  Edit,
  Trash2,
  Users,
  Receipt
} from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';
import { corresponde, filtrarEOrdenar } from '../lib/pesquisa';
import { CATEGORIAS_DE_DESPESA, nomeDaCategoria } from '../lib/categorias';
import { INICIO_DAS_CONTAS, dataDasContas } from '../lib/estatisticas';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Payments = ({ language, translations }) => {
  const { isAdmin } = useAuth();
  const [payments, setPayments] = useState([]);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [dateFilter, setDateFilter] = useState('all');
  const [selectedMember, setSelectedMember] = useState('all');
  const [memberSearch, setMemberSearch] = useState('');
  const [editingPayment, setEditingPayment] = useState(null);
  const [expenses, setExpenses] = useState([]);
  const [sales, setSales] = useState([]);
  const [activities, setActivities] = useState([]);
  const [showAddExpenseDialog, setShowAddExpenseDialog] = useState(false);
  // Filtros da lista de despesas: por periodo (ou um dia certo) e por tipo
  const [trials, setTrials] = useState([]);
  const [despesasFiltradas, setDespesasFiltradas] = useState([]);
  const [despesaAEditar, setDespesaAEditar] = useState(null);
  const [despesasAbertas, setDespesasAbertas] = useState(false);
  const [expenseDateFilter, setExpenseDateFilter] = useState('thisYear');
  const [expenseCategoryFilter, setExpenseCategoryFilter] = useState('all');
  const [expenseDay, setExpenseDay] = useState('');
  const [expenseFrom, setExpenseFrom] = useState('');
  const [expenseTo, setExpenseTo] = useState('');
  const [expenseFormData, setExpenseFormData] = useState({
    description: '',
    amount: '',
    expense_date: '',
    category: ''
  });

  const todayISO = () => new Date().toISOString().split('T')[0];

  const nomeDoMes = (quando = new Date()) => {
    const texto = quando.toLocaleDateString('pt-PT', { month: 'long', year: 'numeric' });
    return texto.charAt(0).toUpperCase() + texto.slice(1);
  };

  const INSURANCE_AMOUNT = '20.00';

  const [formData, setFormData] = useState({
    member_id: '',
    amount: '',
    payment_date: todayISO(),
    payment_type: 'quota',
    payment_method: 'cash',
    description: ''
  });

  const t = {
    pt: {
      payments: 'Gestão de Finanças',
      addPayment: 'Registar Pagamento',
      addExpense: 'Registar Despesa',
      searchPayments: 'Procurar pagamentos...',
      allStatuses: 'Todos os Status',
      paid: 'Pago',
      pending: 'Pendente',
      overdue: 'Em Atraso',
      allMembers: 'Todos os Membros',
      allDates: 'Todas as Datas',
      thisMonth: 'Este Mês',
      lastMonth: 'Mês Passado',
      thisYear: 'Este Ano',
      member: 'Membro',
      amount: 'Valor',
      paymentMethod: 'Método de Pagamento',
      cash: 'Numerário',
      card: 'Cartão',
      transfer: 'Transferência',
      mbway: 'MBWay',
      description: 'Descrição',
      paymentDate: 'Data do Pagamento',
    category: 'Categoria',
    selectCategory: 'Selecionar categoria',
    categoryRent: 'Renda',
    categorySalaries: 'Salários (Prof., colaboradores)',
    categoryAccountant: 'Contabilista',
    categoryTechnology: 'Tecnologia (Hostinger, Site, Meta, etc.)',
    categoryEnergy: 'Energia (Luz, Gás, Água)',
    categoryInfrastructure: 'Infraestruturas (Obras)',
    categoryMerchandise: 'Merchandise',
    categoryMarketing: 'Marketing (Redes sociais, multimédia)',
    categoryLicenses: 'Licenças (Seguros)',
    categoryFnb: 'F&B (Alimentos e bebidas)',
    expensesList: 'Despesas Registadas',
    openExpenses: 'Ver, corrigir e apagar →',
    countsIn: 'Conta em',
    accountsStart: 'As contas começam a 1 de outubro de 2026, quando o ginásio passou a registar tudo. O que é anterior continua guardado na ficha de cada sócio, mas não entra nestes totais.',
    expenseDescriptionHint: 'Opcional — sem texto, fica identificada pela categoria',
    allCategories: 'Todos os tipos',
    dayToday: 'Hoje',
    lastYear: 'Ano Passado',
    pickDay: 'Escolher dia',
    pickRange: 'Escolher intervalo',
    day: 'Dia',
    from: 'De',
    to: 'Até',
    noExpenses: 'Nenhuma despesa para este filtro.',
    expensesTotal: 'Total do filtro',
    noCategory: 'Sem categoria',
      status: 'Status',
      save: 'Guardar',
      cancel: 'Cancelar',
      view: 'Ver',
      edit: 'Editar',
      actions: 'Ações',
      editPayment: 'Corrigir Pagamento',
      delete: 'Eliminar',
      confirmDeletePayment: 'Eliminar este pagamento? As validades do sócio serão recalculadas.',
      paymentDeleted: 'Pagamento eliminado e validades recalculadas.',
      paymentUpdated: 'Pagamento corrigido.',
      totalRevenue: 'Receitas (Quotas)',
      merchandise: 'Merchandise (Vendas)',
      monthlyExpenses: 'Despesas do Mês',
      billing: 'Faturação',
      billingYear: 'Faturação (anual)',
      billingMonth: 'Faturação (mensal)',
      billingDay: 'Faturação (diária)',
      expenseYear: 'Despesa (anual)',
      expenseMonth: 'Despesa (mensal)',
      expenseDay: 'Despesa (diária)',
      netYear: 'Resultado líquido (anual)',
      netMonth: 'Resultado líquido (mensal)',
      today: 'hoje',
      expenses: 'Despesa',
      sinceAlways: 'desde sempre',
      paymentType: 'Tipo de Pagamento',
      modalities: 'Modalidades',
      dailyRevenue: 'Receita Diária',
      quotaBadge: 'Quota',
      insuranceBadge: 'Seguro',
      bothBadge: 'Quota + Seguro',
      typeQuota: 'Quota (mensalidade)',
      typeInsurance: 'Seguro (anual)',
      typeBoth: 'Mensalidade + Seguro',
      insuranceHint: 'Renova o seguro do sócio por um ano a partir da data do pagamento.',
      bothHint: 'Escreve o valor total (mensalidade + 20 € de seguro). Renova a mensalidade por um mês e o seguro por um ano.',
      insuranceRevenue: 'Seguros',
      merchandiseMonth: 'este mês',
      units: 'unidades vendidas',
      recentSales: 'Vendas de Merchandise',
      noSales: 'Ainda não há vendas registadas',
      item: 'Artigo',
      monthlyRevenue: 'Receita Mensal',
      pendingPayments: 'Despesas',
      recentPayments: 'Pagamentos Recentes',
      noPayments: 'Nenhum pagamento encontrado',
      paymentAdded: 'Pagamento registado com sucesso!',
      expenseAdded: 'Despesa registada com sucesso!',
      expenseUpdated: 'Despesa corrigida.',
      expenseDeleted: 'Despesa eliminada.',
      editExpense: 'Corrigir Despesa',
      export: 'Exportar',
      paymentDetails: 'Detalhes do Pagamento',
      membershipPayment: 'Pagamento de Membership',
      selectMember: 'Selecionar membro...',
      enterAmount: 'Inserir valor...',
      paymentDescription: 'Descrição do pagamento...'
    },
    en: {
      payments: 'Finance Management',
      addPayment: 'Add Payment',
      addExpense: 'Add Expense',
      searchPayments: 'Search payments...',
      allStatuses: 'All Statuses',
      paid: 'Paid',
      pending: 'Pending',
      overdue: 'Overdue',
      allMembers: 'All Members',
      allDates: 'All Dates',
      thisMonth: 'This Month',
      lastMonth: 'Last Month',
      thisYear: 'This Year',
      member: 'Member',
      amount: 'Amount',
      paymentMethod: 'Payment Method',
      cash: 'Cash',
      card: 'Card',
      transfer: 'Transfer',
      mbway: 'MBWay',
      description: 'Description',
      paymentDate: 'Payment Date',
    category: 'Category',
    selectCategory: 'Select category',
    categoryRent: 'Rent',
    categorySalaries: 'Salaries (teachers, staff)',
    categoryAccountant: 'Accountant',
    categoryTechnology: 'Technology (Hostinger, website, Meta, etc.)',
    categoryEnergy: 'Energy (electricity, gas, water)',
    categoryInfrastructure: 'Infrastructure (works)',
    categoryMerchandise: 'Merchandise',
    categoryMarketing: 'Marketing (social media, multimedia)',
    categoryLicenses: 'Licences (insurance)',
    categoryFnb: 'F&B (food and drinks)',
    expensesList: 'Recorded Expenses',
    openExpenses: 'View, edit and delete →',
    countsIn: 'Counts in',
    accountsStart: 'The accounts start on 1 October 2026, when the gym began recording everything. Earlier records are kept on each member’s file but do not count towards these totals.',
    expenseDescriptionHint: 'Optional — without text, the category identifies it',
    allCategories: 'All types',
    dayToday: 'Today',
    lastYear: 'Last Year',
    pickDay: 'Pick a day',
    pickRange: 'Pick a range',
    day: 'Day',
    from: 'From',
    to: 'To',
    noExpenses: 'No expenses for this filter.',
    expensesTotal: 'Filter total',
    noCategory: 'No category',
      status: 'Status',
      save: 'Save',
      cancel: 'Cancel',
      view: 'View',
      edit: 'Edit',
      actions: 'Actions',
      editPayment: 'Edit Payment',
      delete: 'Delete',
      confirmDeletePayment: 'Delete this payment? The member validities will be recalculated.',
      paymentDeleted: 'Payment deleted and validities recalculated.',
      paymentUpdated: 'Payment updated.',
      totalRevenue: 'Revenue (Fees)',
      merchandise: 'Merchandise (Sales)',
      monthlyExpenses: 'Expenses This Month',
      billing: 'Billing',
      billingYear: 'Billing (year)',
      billingMonth: 'Billing (month)',
      billingDay: 'Billing (day)',
      expenseYear: 'Expenses (year)',
      expenseMonth: 'Expenses (month)',
      expenseDay: 'Expenses (day)',
      netYear: 'Net result (year)',
      netMonth: 'Net result (month)',
      today: 'today',
      expenses: 'Expenses',
      sinceAlways: 'all time',
      paymentType: 'Payment Type',
      modalities: 'Activities',
      dailyRevenue: 'Daily Revenue',
      quotaBadge: 'Fee',
      insuranceBadge: 'Insurance',
      bothBadge: 'Fee + Insurance',
      typeQuota: 'Membership fee',
      typeInsurance: 'Insurance (yearly)',
      typeBoth: 'Membership + Insurance',
      insuranceHint: "Renews the member's insurance for one year from the payment date.",
      bothHint: 'Enter the total (fee + €20 insurance). Renews the fee for a month and the insurance for a year.',
      insuranceRevenue: 'Insurance',
      merchandiseMonth: 'this month',
      units: 'units sold',
      recentSales: 'Merchandise Sales',
      noSales: 'No sales recorded yet',
      item: 'Item',
      monthlyRevenue: 'Monthly Revenue',
      pendingPayments: 'Expenses',
      recentPayments: 'Recent Payments',
      noPayments: 'No payments found',
      paymentAdded: 'Payment added successfully!',
      expenseAdded: 'Expense added successfully!',
      expenseUpdated: 'Expense updated.',
      expenseDeleted: 'Expense deleted.',
      editExpense: 'Edit Expense',
      export: 'Export',
      paymentDetails: 'Payment Details',
      membershipPayment: 'Membership Payment',
      selectMember: 'Select member...',
      enterAmount: 'Enter amount...',
      paymentDescription: 'Payment description...'
    }
  };

  useEffect(() => {
    fetchMembers();
    fetchPayments();
    fetchExpenses();
    fetchSales();
    fetchTrials();
    fetchActivities();
  }, []);

  useEffect(() => {
    // Espera 300ms enquanto se escreve: sem isto, cada letra lancava uma
    // leitura, e a mais antiga chegava depois e mostrava a lista por filtrar
    const espera = setTimeout(() => fetchPayments(), 300);
    return () => clearTimeout(espera);
  }, [statusFilter, dateFilter, selectedMember, searchTerm]);

  useEffect(() => {
    fetchDespesasFiltradas();
  }, [expenseDateFilter, expenseCategoryFilter, expenseDay, expenseFrom, expenseTo]);

  const fetchMembers = async () => {
    try {
      const response = await axios.get(`${API}/members`);
      setMembers(response.data);
    } catch (error) {
      console.error('Error fetching members:', error);
    }
  };

  const fetchActivities = async () => {
    try {
      const response = await axios.get(`${API}/activities`);
      setActivities(response.data);
    } catch (error) {
      console.error('Error fetching activities:', error);
    }
  };

  const memberActivities = (member) => {
    const ids = member?.activity_ids?.length
      ? member.activity_ids
      : (member?.activity_id ? [member.activity_id] : []);
    return ids.map((id) => activities.find((a) => a.id === id)).filter(Boolean);
  };

  const fetchSales = async () => {
    try {
      const response = await axios.get(`${API}/sales`);
      setSales(response.data);
    } catch (error) {
      console.error('Error fetching sales:', error);
    }
  };

  /** As aulas experimentais sao pagas: o que rendem entra na faturacao. */
  const fetchTrials = async () => {
    try {
      const response = await axios.get(`${API}/trials`);
      setTrials(response.data);
    } catch (error) {
      console.error('Error fetching trials:', error);
    }
  };

  /**
   * O intervalo de datas que corresponde ao filtro escolhido.
   * As datas sao montadas a partir dos componentes locais: `toISOString()`
   * recua um dia em Portugal.
   */
  const intervaloDasDespesas = () => {
    const dia = (d) =>
      `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    const hoje = new Date();

    switch (expenseDateFilter) {
      case 'today':
        return { de: dia(hoje), ate: dia(hoje) };
      case 'thisMonth':
        return {
          de: dia(new Date(hoje.getFullYear(), hoje.getMonth(), 1)),
          ate: dia(new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0))
        };
      case 'lastMonth':
        return {
          de: dia(new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1)),
          ate: dia(new Date(hoje.getFullYear(), hoje.getMonth(), 0))
        };
      case 'thisYear':
        return { de: `${hoje.getFullYear()}-01-01`, ate: `${hoje.getFullYear()}-12-31` };
      case 'lastYear':
        return { de: `${hoje.getFullYear() - 1}-01-01`, ate: `${hoje.getFullYear() - 1}-12-31` };
      case 'day':
        return expenseDay ? { de: expenseDay, ate: expenseDay } : {};
      case 'range':
        return { de: expenseFrom || undefined, ate: expenseTo || undefined };
      default:
        return {};
    }
  };

  const pedidoDeDespesas = useRef(0);

  /** A lista toda, que alimenta os cartoes de Despesa (anual, mensal, diaria). */
  const fetchExpenses = async () => {
    try {
      const response = await axios.get(`${API}/expenses`);
      setExpenses(response.data);
    } catch (error) {
      console.error('Error fetching expenses:', error);
    }
  };

  /** A lista que se esta a consultar, com os filtros aplicados pelo servidor. */
  const fetchDespesasFiltradas = async () => {
    const meuPedido = ++pedidoDeDespesas.current;
    try {
      const params = new URLSearchParams();
      const { de, ate } = intervaloDasDespesas();
      if (de) params.append('start_date', de);
      if (ate) params.append('end_date', ate);
      if (expenseCategoryFilter !== 'all') params.append('category', expenseCategoryFilter);

      const response = await axios.get(`${API}/expenses?${params}`);
      // Uma leitura antiga que chegue depois nao pode substituir a mais recente
      if (meuPedido !== pedidoDeDespesas.current) return;
      setDespesasFiltradas(response.data);
    } catch (error) {
      console.error('Error fetching expenses:', error);
    }
  };

  const pedidoAtual = useRef(0);

  const fetchPayments = async () => {
    const meuPedido = ++pedidoAtual.current;
    try {
      setLoading(true);
      const params = new URLSearchParams();
      
      if (statusFilter !== 'all') params.append('status', statusFilter);
      if (selectedMember !== 'all') params.append('member_id', selectedMember);
      
      // Date filters
      const now = new Date();
      if (dateFilter === 'thisMonth') {
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        params.append('start_date', startOfMonth.toISOString().split('T')[0]);
      } else if (dateFilter === 'lastMonth') {
        const startOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        const endOfLastMonth = new Date(now.getFullYear(), now.getMonth(), 0);
        params.append('start_date', startOfLastMonth.toISOString().split('T')[0]);
        params.append('end_date', endOfLastMonth.toISOString().split('T')[0]);
      } else if (dateFilter === 'thisYear') {
        const startOfYear = new Date(now.getFullYear(), 0, 1);
        params.append('start_date', startOfYear.toISOString().split('T')[0]);
      }
      
      // Dois pedidos, e não um por cada pagamento: com mil pagamentos, o
      // ecrã fazia mais de mil pedidos ao servidor e demorava uma eternidade
      const [respostaPagamentos, respostaMembros] = await Promise.all([
        axios.get(`${API}/payments?${params}`),
        axios.get(`${API}/members`)
      ]);

      const porId = new Map(respostaMembros.data.map((m) => [m.id, m]));

      let paymentsWithMembers = respostaPagamentos.data.map((payment) => ({
        ...payment,
        member: porId.get(payment.member_id) || {
          name: 'Membro eliminado',
          id: payment.member_id,
          member_number: 'N/A',
          nome: 'Desconhecido'
        }
      }));
      
      // Filter by search term if provided
      if (searchTerm) {
        paymentsWithMembers = paymentsWithMembers.filter((payment) =>
          corresponde(
            searchTerm,
            payment.member?.name,
            [payment.description],
            [payment.member?.member_number, payment.member?.phone]
          )
        );
      }
      
      // Mais recentes no topo
      paymentsWithMembers.sort((a, b) => {
        const dataA = new Date(a.payment_date), dataB = new Date(b.payment_date);
        if (dataA.getTime() !== dataB.getTime()) return dataB - dataA;
        return new Date(b.created_at) - new Date(a.created_at);
      });

      // Se entretanto foi pedida outra leitura, esta ja nao interessa
      if (meuPedido !== pedidoAtual.current) return;

      setPayments(paymentsWithMembers);
    } catch (error) {
      console.error('Error fetching payments:', error);
      toast.error('Erro ao carregar pagamentos');
    } finally {
      setLoading(false);
    }
  };

  const editarPagamento = (payment) => {
    setEditingPayment(payment);
    setMemberSearch('');
    setFormData({
      member_id: payment.member_id,
      amount: String(payment.amount),
      payment_date: String(payment.payment_date).split('T')[0],
      payment_type: payment.payment_type || 'quota',
      payment_method: payment.payment_method || 'cash',
      description: payment.description || ''
    });
    setShowAddDialog(true);
  };

  const apagarPagamento = async (payment) => {
    if (!window.confirm(t[language].confirmDeletePayment)) return;
    try {
      await axios.delete(`${API}/payments/${payment.id}`);
      toast.success(t[language].paymentDeleted);
      fetchPayments();
      fetchMembers();
    } catch (error) {
      console.error('Error deleting payment:', error);
      toast.error(error.response?.data?.detail || 'Erro ao eliminar o pagamento');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.member_id) {
      toast.error('Escolhe o aluno na lista.');
      return;
    }

    const corpo = {
      ...formData,
      amount: parseFloat(formData.amount),
      payment_date: formData.payment_date || null
    };

    try {
      if (editingPayment) {
        await axios.put(`${API}/payments/${editingPayment.id}`, corpo);
        toast.success(t[language].paymentUpdated);
      } else {
        await axios.post(`${API}/payments`, corpo);
        toast.success(t[language].paymentAdded);
      }

      // Qualquer pagamento altera as validades do sócio
      fetchMembers();
      setShowAddDialog(false);
      setEditingPayment(null);
      resetForm();
      fetchPayments();
    } catch (error) {
      console.error('Error saving payment:', error);
      toast.error(error.response?.data?.detail || 'Erro ao guardar o pagamento');
    }
  };

  const resetForm = () => {
    setMemberSearch('');
    setFormData({
      member_id: '',
      amount: '',
      payment_date: todayISO(),
      payment_type: 'quota',
      payment_method: 'cash',
      description: ''
    });
  };

  const handleAddExpense = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        // Sem texto, a despesa fica identificada pela categoria e pela data
        description: expenseFormData.description.trim() || null,
        amount: parseFloat(expenseFormData.amount)
      };
      if (expenseFormData.expense_date) {
        payload.expense_date = expenseFormData.expense_date;
      }
      if (expenseFormData.category) {
        payload.category = expenseFormData.category;
      }

      if (despesaAEditar) {
        await axios.put(`${API}/expenses/${despesaAEditar.id}`, payload);
        toast.success(t[language].expenseUpdated);
      } else {
        await axios.post(`${API}/expenses`, payload);
        toast.success(t[language].expenseAdded);
      }

      setShowAddExpenseDialog(false);
      setDespesaAEditar(null);
      resetExpenseForm();
      fetchExpenses();
      fetchDespesasFiltradas();
    } catch (error) {
      console.error('Error saving expense:', error);
      toast.error(despesaAEditar ? 'Erro ao corrigir a despesa' : 'Erro ao registar despesa');
    }
  };

  const abrirCorrecaoDaDespesa = (despesa) => {
    setDespesaAEditar(despesa);
    setExpenseFormData({
      description: despesa.description || '',
      amount: String(despesa.amount ?? ''),
      expense_date: String(despesa.expense_date || '').split('T')[0],
      category: despesa.category || ''
    });
    setShowAddExpenseDialog(true);
  };

  const apagarDespesa = async (despesa) => {
    const nome = despesa.description || nomeDaCategoria(despesa.category);
    if (!window.confirm(`Apagar a despesa "${nome}"? Esta ação não se desfaz.`)) return;
    try {
      await axios.delete(`${API}/expenses/${despesa.id}`);
      toast.success(t[language].expenseDeleted);
      fetchExpenses();
      fetchDespesasFiltradas();
    } catch (error) {
      console.error('Error deleting expense:', error);
      toast.error('Erro ao eliminar a despesa');
    }
  };

  const resetExpenseForm = () => {
    setExpenseFormData({
      description: '',
      amount: '',
      expense_date: '',
      category: ''
    });
  };

  const getStatusVariant = (status) => {
    switch (status) {
      case 'paid': return 'default';
      case 'pending': return 'secondary';
      case 'overdue': return 'destructive';
      default: return 'secondary';
    }
  };

  const getPaymentMethodColor = (method) => {
    switch (method) {
      case 'cash': return 'bg-green-100 text-green-800';
      case 'card': return 'bg-blue-100 text-blue-800';
      case 'transfer': return 'bg-purple-100 text-purple-800';
      case 'mbway': return 'bg-orange-100 text-orange-800';
      default: return 'bg-gray-100 text-gray-800 dark:text-gray-100';
    }
  };

  const getPaymentStats = () => {
    const pagos = payments.filter((p) => p.status === 'paid');
    const seguroFixo = parseFloat(INSURANCE_AMOUNT);

    // Num pagamento combinado, os 20 € do seguro contam como seguro e o
    // restante como quota, para as duas receitas não se confundirem
    const parteSeguro = (p) => {
      if (p.payment_type === 'seguro') return p.amount;
      if (p.payment_type === 'quota_seguro') return Math.min(seguroFixo, p.amount);
      return 0;
    };

    const hoje = new Date();
    // As contas do ginásio começam no dia em que o sistema passou a ser usado
    // a sério. Antes disso faltam despesas por registar, e o lucro que daí
    // saía não existiu. Os dados antigos continuam guardados, só não contam.
    const corte = new Date(INICIO_DAS_CONTAS.ano, INICIO_DAS_CONTAS.mes - 1, INICIO_DAS_CONTAS.dia);
    const maisTarde = (a, b) => (a > b ? a : b);
    const inicioDoAno = maisTarde(new Date(hoje.getFullYear(), 0, 1), corte);
    const inicioDoMes = maisTarde(new Date(hoje.getFullYear(), hoje.getMonth(), 1), corte);

    const noPeriodo = (valorData, desde) => {
      const d = new Date(valorData);
      if (desde === 'hoje') {
        return d.getFullYear() === hoje.getFullYear()
          && d.getMonth() === hoje.getMonth()
          && d.getDate() === hoje.getDate();
      }
      return d >= desde;
    };

    const somar = (lista, campoData, campoValor, desde) =>
      lista
        .filter((x) => noPeriodo(x[campoData], desde))
        .reduce((total, x) => total + (campoValor(x) || 0), 0);

    // FATURAÇÃO = tudo o que o ginásio faturou: quotas, seguros, merchandise
    // e aulas experimentais, que são pagas
    // Os pagamentos contam pela data das contas, que só difere nos do fim de
    // setembro de 2026: eram a mensalidade de outubro
    const somarPagamentos = (desde) =>
      pagos
        .filter((p) => noPeriodo(dataDasContas(p), desde))
        .reduce((total, p) => total + (p.amount || 0), 0);

    const faturacao = (desde) =>
      somarPagamentos(desde) +
      somar(sales, 'sale_date', (v) => v.total, desde) +
      somar(trials, 'trial_date', (e) => e.amount, desde);

    const despesa = (desde) => somar(expenses, 'expense_date', (e) => e.amount, desde);

    const faturacaoAnual = faturacao(inicioDoAno);
    const faturacaoMensal = faturacao(inicioDoMes);
    const faturacaoDiaria = faturacao('hoje');

    const despesaAnual = despesa(inicioDoAno);
    const despesaMensal = despesa(inicioDoMes);
    const despesaDiaria = despesa('hoje');

    return {
      ano: hoje.getFullYear(),
      faturacaoAnual,
      faturacaoMensal,
      faturacaoDiaria,
      despesaAnual,
      despesaMensal,
      despesaDiaria,
      // RESULTADO LÍQUIDO = faturação menos despesa, no mesmo período
      liquidoAnual: faturacaoAnual - despesaAnual,
      liquidoMensal: faturacaoMensal - despesaMensal,
      // Detalhe, para quem quiser perceber de onde vem a faturação
      quotasAnual: pagos
        .filter((p) => noPeriodo(dataDasContas(p), inicioDoAno))
        .reduce((t, p) => t + (p.amount - parteSeguro(p)), 0),
      segurosAnual: pagos
        .filter((p) => noPeriodo(dataDasContas(p), inicioDoAno))
        .reduce((t, p) => t + parteSeguro(p), 0),
      experimentaisAnual: somar(trials, 'trial_date', (e) => e.amount, inicioDoAno),
      merchandiseAnual: somar(sales, 'sale_date', (v) => v.total, inicioDoAno),
      pendingCount: payments.filter((p) => p.status === 'pending').length
    };
  };

  const exportPayments = () => {
    const csvContent = [
      ['Data', 'Membro', 'Valor', 'Método', 'Status', 'Descrição'],
      ...payments.map(payment => [
        payment.payment_date,
        payment.member.name,
        payment.amount,
        payment.payment_method,
        payment.status,
        payment.description || ''
      ])
    ].map(row => row.join(',')).join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `pagamentos_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
  };

  const stats = getPaymentStats();

  const getSearchedMembers = () =>
    filtrarEOrdenar(members, memberSearch, (m) => ({
      principal: m.name,
      extras: [],
      numeros: [m.member_number, m.phone]
    }));

  const getSelectedMemberObject = () => members.find((m) => m.id === formData.member_id);

  return (
    <div className="p-6 space-y-6 fade-in">
      {/* Header */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4 lg:mb-0">
          {t[language].payments}
        </h1>

        <div className="flex flex-wrap gap-3 mb-4 lg:mb-0">
          <Button
            className="btn-hover bg-green-600 hover:bg-green-700 text-white"
            onClick={() => { resetForm(); setEditingPayment(null); setShowAddDialog(true); }}
            data-testid="add-payment-btn"
          >
            <Plus className="mr-2" size={16} />
            {t[language].addPayment}
          </Button>
          <Button
            className="btn-hover bg-orange-500 hover:bg-orange-600 text-white"
            onClick={() => { setDespesaAEditar(null); resetExpenseForm(); setShowAddExpenseDialog(true); }}
            data-testid="add-expense-btn"
          >
            <Plus className="mr-2" size={16} />
            {t[language].addExpense}
          </Button>
        </div>

        
        <Dialog
          open={showAddDialog}
          onOpenChange={(aberto) => { setShowAddDialog(aberto); if (!aberto) setEditingPayment(null); }}
        >
        <DialogContent className="max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle>
                {editingPayment ? t[language].editPayment : t[language].addPayment}
              </DialogTitle>
            </DialogHeader>
            
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="member_search">{t[language].member} *</Label>

                <div className="relative">
                  <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-500" />
                  <Input
                    id="member_search"
                    value={memberSearch}
                    onChange={(e) => setMemberSearch(e.target.value)}
                    placeholder="Procurar por nome ou numero do aluno..."
                    className="pl-9"
                    autoComplete="off"
                    data-testid="payment-member-search"
                  />
                </div>

                <div className="mt-2 border rounded-lg max-h-[8.25rem] overflow-y-auto" data-testid="payment-member-list">
                  {getSearchedMembers().length > 0 ? (
                    getSearchedMembers().map((member) => {
                      const selected = formData.member_id === member.id;
                      return (
                        <button
                          key={member.id}
                          type="button"
                          onClick={() => setFormData({...formData, member_id: member.id})}
                          className={`w-full text-left px-3 py-2 flex items-center justify-between border-b last:border-b-0 transition-colors ${
                            selected ? 'font-medium' : 'hover:bg-gray-50'
                          }`}
                          style={{ background: selected ? 'rgba(184, 101, 27, 0.18)' : 'transparent', color: 'var(--text-primary)' }}
                          data-testid={`payment-member-${member.id}`}
                        >
                          <span className="flex items-center gap-2">
                            <Badge variant="outline">{member.member_number}</Badge>
                            <span>{member.name}</span>
                          </span>
                        </button>
                      );
                    })
                  ) : (
                    <p className="text-sm text-gray-500 dark:text-gray-400 text-center py-4">Nenhum aluno encontrado</p>
                  )}
                </div>

                {formData.member_id && getSelectedMemberObject() && (
                  <p className="text-sm mt-2" style={{ color: 'var(--ko-primary-orange)' }}>
                    Aluno selecionado: <strong>{getSelectedMemberObject().name}</strong> (n.º {getSelectedMemberObject().member_number})
                  </p>
                )}
              </div>
              
              <div>
                <Label htmlFor="payment_type">{t[language].paymentType} *</Label>
                <Select
                  value={formData.payment_type}
                  onValueChange={(value) => setFormData({
                    ...formData,
                    payment_type: value,
                    // Só o seguro isolado tem valor fixo; nos outros o valor é escrito
                    amount: value === 'seguro' ? INSURANCE_AMOUNT : (formData.amount === INSURANCE_AMOUNT ? '' : formData.amount)
                  })}
                >
                  <SelectTrigger data-testid="payment-type">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="quota">{t[language].typeQuota}</SelectItem>
                    <SelectItem value="seguro">{t[language].typeInsurance}</SelectItem>
                    <SelectItem value="quota_seguro">{t[language].typeBoth}</SelectItem>
                  </SelectContent>
                </Select>
                {formData.payment_type === 'seguro' && (
                  <p className="text-xs mt-1" style={{ color: 'var(--ko-primary-orange)' }}>
                    {t[language].insuranceHint}
                  </p>
                )}
                {formData.payment_type === 'quota_seguro' && (
                  <p className="text-xs mt-1" style={{ color: 'var(--ko-primary-orange)' }}>
                    {t[language].bothHint}
                  </p>
                )}
              </div>

              <div>
                <Label htmlFor="amount">{t[language].amount} (€) *</Label>
                <Input
                  id="amount"
                  type="number"
                  step="0.01"
                  min="0"
                  value={formData.amount}
                  onChange={(e) => setFormData({...formData, amount: e.target.value})}
                  required
                  placeholder={t[language].enterAmount}
                  data-testid="payment-amount"
                />
              </div>
              
              <div>
                <Label htmlFor="payment_date">{t[language].paymentDate} *</Label>
                <Input
                  id="payment_date"
                  type="date"
                  value={formData.payment_date}
                  onChange={(e) => setFormData({...formData, payment_date: e.target.value})}
                  required
                  data-testid="payment-date"
                />
              </div>

              <div>
                <Label htmlFor="payment_method">{t[language].paymentMethod} *</Label>
                <Select 
                  value={formData.payment_method} 
                  onValueChange={(value) => setFormData({...formData, payment_method: value})}
                >
                  <SelectTrigger data-testid="payment-method">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="cash">{t[language].cash}</SelectItem>
                    <SelectItem value="card">{t[language].card}</SelectItem>
                    <SelectItem value="transfer">{t[language].transfer}</SelectItem>
                    <SelectItem value="mbway">{t[language].mbway}</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              
              <div>
                <Label htmlFor="description">{t[language].description}</Label>
                <Textarea
                  id="description"
                  value={formData.description}
                  onChange={(e) => setFormData({...formData, description: e.target.value})}
                  rows={3}
                  placeholder={t[language].paymentDescription}
                  data-testid="payment-description"
                />
              </div>
              
              <div className="flex justify-end gap-3 pt-4">
                <Button 
                  type="button" 
                  variant="outline" 
                  onClick={() => setShowAddDialog(false)}
                >
                  {t[language].cancel}
                </Button>
                <Button type="submit" data-testid="save-payment-btn">
                  {t[language].save}
                </Button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
      </div>

      <Dialog
        open={showAddExpenseDialog}
        onOpenChange={(aberto) => {
          setShowAddExpenseDialog(aberto);
          if (!aberto) { setDespesaAEditar(null); resetExpenseForm(); }
        }}
      >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {despesaAEditar ? t[language].editExpense : t[language].addExpense}
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleAddExpense} className="space-y-4">
          <div>
            <Label htmlFor="expense-category">{t[language].category}</Label>
            <Select value={expenseFormData.category} onValueChange={(value) => setExpenseFormData({...expenseFormData, category: value})}>
              <SelectTrigger id="expense-category" data-testid="expense-category">
                <SelectValue placeholder={t[language].selectCategory} />
              </SelectTrigger>
              <SelectContent className="max-h-72">
                <SelectItem value="rent">{t[language].categoryRent}</SelectItem>
                <SelectItem value="salaries">{t[language].categorySalaries}</SelectItem>
                <SelectItem value="accountant">{t[language].categoryAccountant}</SelectItem>
                <SelectItem value="technology">{t[language].categoryTechnology}</SelectItem>
                <SelectItem value="energy">{t[language].categoryEnergy}</SelectItem>
                <SelectItem value="infrastructure">{t[language].categoryInfrastructure}</SelectItem>
                <SelectItem value="merchandise">{t[language].categoryMerchandise}</SelectItem>
                <SelectItem value="marketing">{t[language].categoryMarketing}</SelectItem>
                <SelectItem value="licenses">{t[language].categoryLicenses}</SelectItem>
                <SelectItem value="fnb">{t[language].categoryFnb}</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label htmlFor="expense-description">{t[language].description}</Label>
            <Textarea
              id="expense-description"
              value={expenseFormData.description}
              onChange={(e) => setExpenseFormData({...expenseFormData, description: e.target.value})}
              placeholder={t[language].expenseDescriptionHint}
              rows={3}
              data-testid="expense-description"
            />
          </div>

          <div>
            <Label htmlFor="expense-amount">{t[language].amount} (€) *</Label>
            <Input
              id="expense-amount"
              type="number"
              step="0.01"
              min="0"
              value={expenseFormData.amount}
              onChange={(e) => setExpenseFormData({...expenseFormData, amount: e.target.value})}
              required
              placeholder={t[language].enterAmount}
              data-testid="expense-amount"
            />
          </div>

          <div>
            <Label htmlFor="expense-date">{t[language].paymentDate}</Label>
            <Input
              id="expense-date"
              type="date"
              value={expenseFormData.expense_date}
              onChange={(e) => setExpenseFormData({...expenseFormData, expense_date: e.target.value})}
            />
          </div>


          <div className="flex justify-end gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={() => setShowAddExpenseDialog(false)}
            >
              {t[language].cancel}
            </Button>
            <Button type="submit" data-testid="save-expense-btn">
              {t[language].save}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>

      {/* Faturação, despesa e resultado líquido */}
      {isAdmin() ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {[
            { titulo: t[language].billingYear, valor: stats.faturacaoAnual, nota: String(stats.ano), cor: 'bg-green-600', icone: DollarSign },
            { titulo: t[language].billingMonth, valor: stats.faturacaoMensal, nota: nomeDoMes(), cor: 'bg-green-500', icone: TrendingUp },
            { titulo: t[language].billingDay, valor: stats.faturacaoDiaria, nota: t[language].today, cor: 'bg-emerald-500', icone: Calendar },
            { titulo: t[language].expenseYear, valor: stats.despesaAnual, nota: String(stats.ano), cor: 'bg-red-600', icone: TrendingDown },
            { titulo: t[language].expenseMonth, valor: stats.despesaMensal, nota: nomeDoMes(), cor: 'bg-red-500', icone: TrendingDown },
            { titulo: t[language].expenseDay, valor: stats.despesaDiaria, nota: t[language].today, cor: 'bg-orange-500', icone: CreditCard },
            { titulo: t[language].netYear, valor: stats.liquidoAnual, nota: String(stats.ano), liquido: true, icone: DollarSign },
            { titulo: t[language].netMonth, valor: stats.liquidoMensal, nota: nomeDoMes(), liquido: true, icone: DollarSign }
          ].map((c) => {
            const Icone = c.icone;
            const negativo = c.liquido && c.valor < 0;
            const corIcone = c.liquido ? (negativo ? 'bg-red-600' : 'bg-emerald-600') : c.cor;
            return (
              <Card key={c.titulo} className="card-shadow">
                <CardContent className="p-5">
                  <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0 flex-1">
                      <p className="text-sm font-medium text-gray-600 dark:text-gray-300 truncate">
                        {c.titulo}
                      </p>
                      <p
                        className="text-2xl font-bold truncate"
                        style={{ color: negativo ? '#dc2626' : 'var(--text-primary)' }}
                      >
                        {c.valor < 0 ? '-' : ''}€{Math.abs(c.valor).toFixed(2)}
                      </p>
                      <p className="text-xs text-gray-500 dark:text-gray-400 truncate">{c.nota}</p>
                    </div>
                    <div className={`p-2.5 rounded-full shrink-0 ${corIcone}`}>
                      <Icone size={20} className="text-white" />
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}

          {/* O lugar vazio da grelha dá acesso à consulta das despesas */}
          <Card
            className="card-shadow cursor-pointer transition-all duration-200 hover:opacity-90"
            onClick={() => setDespesasAbertas(true)}
            data-testid="abrir-despesas"
          >
            <CardContent className="p-5">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-gray-600 dark:text-gray-300 truncate">
                    {t[language].expensesList}
                  </p>
                  <p className="text-2xl font-bold truncate" style={{ color: 'var(--text-primary)' }}>
                    {despesasFiltradas.length}
                  </p>
                  <p className="text-xs truncate" style={{ color: 'var(--ko-primary-orange)' }}>
                    {t[language].openExpenses}
                  </p>
                </div>
                <div className="p-2.5 rounded-full shrink-0 bg-orange-600">
                  <Receipt size={20} className="text-white" />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      ) : (
        /* O colaborador não vê contas do ginásio: só os botões de registar */
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Card className="card-shadow">
            <CardContent className="p-5 flex items-center justify-between gap-3">
              <p className="font-medium" style={{ color: 'var(--text-primary)' }}>
                {t[language].billing}
              </p>
              <div className="p-2.5 rounded-full bg-green-600 shrink-0">
                <DollarSign size={20} className="text-white" />
              </div>
            </CardContent>
          </Card>
          <Card
            className="card-shadow cursor-pointer transition-all duration-200 hover:opacity-90"
            onClick={() => setDespesasAbertas(true)}
            data-testid="abrir-despesas"
          >
            <CardContent className="p-5 flex items-center justify-between gap-3">
              <div className="min-w-0">
                <p className="font-medium truncate" style={{ color: 'var(--text-primary)' }}>
                  {t[language].expenses}
                </p>
                <p className="text-xs truncate" style={{ color: 'var(--ko-primary-orange)' }}>
                  {t[language].openExpenses}
                </p>
              </div>
              <div className="p-2.5 rounded-full bg-orange-500 shrink-0">
                <Receipt size={20} className="text-white" />
              </div>
            </CardContent>
          </Card>
        </div>
      )}


      {isAdmin() && (
        <p className="text-xs -mt-2" style={{ color: 'var(--text-secondary)' }}>
          {t[language].accountsStart}
        </p>
      )}

      {/* Filters */}
      <Card>
        <CardContent className="p-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="relative">
              <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400 dark:text-gray-500" />
              <Input
                placeholder={t[language].searchPayments}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10"
                data-testid="payments-search"
              />
            </div>
            
            <Select value={statusFilter} onValueChange={setStatusFilter}>
              <SelectTrigger>
                <SelectValue placeholder={t[language].allStatuses} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">{t[language].allStatuses}</SelectItem>
                <SelectItem value="paid">{t[language].paid}</SelectItem>
                <SelectItem value="pending">{t[language].pending}</SelectItem>
                <SelectItem value="overdue">{t[language].overdue}</SelectItem>
              </SelectContent>
            </Select>
            
            <Select value={dateFilter} onValueChange={setDateFilter}>
              <SelectTrigger>
                <SelectValue placeholder={t[language].allDates} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">{t[language].allDates}</SelectItem>
                <SelectItem value="thisMonth">{t[language].thisMonth}</SelectItem>
                <SelectItem value="lastMonth">{t[language].lastMonth}</SelectItem>
                <SelectItem value="thisYear">{t[language].thisYear}</SelectItem>
              </SelectContent>
            </Select>
            
            <Select value={selectedMember} onValueChange={setSelectedMember}>
              <SelectTrigger>
                <SelectValue placeholder={t[language].allMembers} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">{t[language].allMembers}</SelectItem>
                {members.map((member) => (
                  <SelectItem key={member.id} value={member.id}>
                    {member.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </CardContent>
      </Card>

      {/* Payments List */}
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle className="flex items-center">
            <CreditCard className="mr-2" />
            {t[language].recentPayments} ({payments.length})
          </CardTitle>
          {isAdmin() && (
            <Button 
              variant="outline" 
              onClick={exportPayments}
              className="btn-hover"
              data-testid="export-payments-btn"
            >
              <Download className="mr-2" size={16} />
              {t[language].export}
            </Button>
          )}
        </CardHeader>
        <CardContent>
          {loading ? (
            <div className="space-y-4">
              {[1, 2, 3].map(i => (
                <div key={i} className="animate-pulse flex items-center space-x-4 p-4">
                  <div className="rounded-full bg-gray-200 h-10 w-10"></div>
                  <div className="flex-1 space-y-2">
                    <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                    <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                  </div>
                </div>
              ))}
            </div>
          ) : payments.length > 0 ? (
            /* Altura limitada: sem isto, mil pagamentos faziam uma pagina de
               dezenas de milhares de pixeis e empurravam tudo o resto para
               fora do alcance */
            <div className="overflow-x-auto max-h-[32rem] overflow-y-auto">
              <table className="w-full">
                <thead className="sticky top-0 z-10 bg-card">
                  <tr className="border-b">
                    <th className="text-left p-4 font-medium text-gray-600 dark:text-gray-300">
                      {t[language].member}
                    </th>
                    <th className="text-left p-4 font-medium text-gray-600 dark:text-gray-300">
                      {isAdmin() ? t[language].amount : t[language].modalities}
                    </th>
                    <th className="text-left p-4 font-medium text-gray-600 dark:text-gray-300">
                      {t[language].paymentMethod}
                    </th>
                    <th className="text-left p-4 font-medium text-gray-600 dark:text-gray-300">
                      {t[language].paymentDate}
                    </th>
                    <th className="text-left p-4 font-medium text-gray-600 dark:text-gray-300">
                      {t[language].status}
                    </th>
                    <th className="text-left p-4 font-medium text-gray-600 dark:text-gray-300">
                      {isAdmin() ? t[language].description : t[language].amount}
                    </th>
                    <th className="text-right p-4 font-medium text-gray-600 dark:text-gray-300">
                      {t[language].actions}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {payments.map((payment) => (
                    <tr key={payment.id} className="border-b hover:bg-gray-50">
                      <td className="p-4">
                        <div className="flex items-center space-x-3">
                          <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                            <Users size={16} className="text-blue-600" />
                          </div>
                          <div>
                            <p className="font-medium">{payment.member.name}</p>
                            <Badge
                              variant="outline"
                              className="mt-1"
                              style={payment.payment_type === 'seguro'
                                ? { borderColor: '#16a34a', color: '#16a34a' }
                                : payment.payment_type === 'quota_seguro'
                                  ? { borderColor: '#2563eb', color: '#2563eb' }
                                  : { borderColor: 'var(--ko-primary-orange)', color: 'var(--ko-primary-orange)' }}
                            >
                              {payment.payment_type === 'seguro'
                                ? t[language].insuranceBadge
                                : payment.payment_type === 'quota_seguro'
                                  ? t[language].bothBadge
                                  : t[language].quotaBadge}
                            </Badge>
                          </div>
                        </div>
                      </td>
                      <td className="p-4">
                        {isAdmin() ? (
                          <div className="flex items-center">
                            <DollarSign size={16} className="text-gray-400 dark:text-gray-500 mr-1" />
                            <span className="font-semibold">€{payment.amount.toFixed(2)}</span>
                          </div>
                        ) : (
                          <div className="flex flex-wrap gap-1">
                            {memberActivities(payment.member).length > 0 ? (
                              memberActivities(payment.member).map((a) => (
                                <Badge key={a.id} variant="outline" style={{ borderColor: a.color, color: a.color }}>
                                  {a.name}
                                </Badge>
                              ))
                            ) : (
                              <span className="text-sm text-gray-500 dark:text-gray-400">—</span>
                            )}
                          </div>
                        )}
                      </td>
                      <td className="p-4">
                        <Badge className={getPaymentMethodColor(payment.payment_method)}>
                          {t[language][payment.payment_method]}
                        </Badge>
                      </td>
                      <td className="p-4">
                        <div className="flex items-center">
                          <Calendar size={16} className="text-gray-400 dark:text-gray-500 mr-2" />
                          {new Date(payment.payment_date).toLocaleDateString('pt-PT')}
                        </div>
                        {/* Um pagamento do fim do mês pode ser a mensalidade do
                            mês seguinte: a data diz quando se pagou, esta nota
                            diz em que mês o dinheiro conta */}
                        {payment.accounting_date
                          && String(payment.accounting_date).split('T')[0]
                             !== String(payment.payment_date).split('T')[0] && (
                          <p className="text-xs mt-1" style={{ color: 'var(--ko-primary-orange)' }}>
                            {t[language].countsIn}{' '}
                            {nomeDoMes(new Date(payment.accounting_date))}
                          </p>
                        )}
                      </td>
                      <td className="p-4">
                        {(() => {
                          // Ligado exclusivamente aos pagamentos do sócio
                          const estado = payment.member?.membership_status;
                          const cor = estado === 'active' ? '#16a34a'
                            : estado === 'suspended' ? '#dc2626' : '#dc2626';
                          const texto = estado === 'active' ? 'ATIVO'
                            : estado === 'suspended' ? 'SUSPENSO' : 'INATIVO';
                          const ate = payment.member?.membership_valid_until;
                          return (
                            <Badge
                              variant="outline"
                              style={{ borderColor: cor, color: cor }}
                              title={ate ? `Quota paga até ${new Date(ate).toLocaleDateString('pt-PT')}` : 'Sem quota registada'}
                            >
                              {texto}
                            </Badge>
                          );
                        })()}
                      </td>
                      <td className="p-4">
                        {isAdmin() ? (
                          <p className="text-sm text-gray-600 dark:text-gray-300 truncate max-w-xs">
                            {payment.description || '-'}
                          </p>
                        ) : (
                          // O colaborador precisa do valor para conferir o que
                          // lançou; os totais do ginásio continuam escondidos
                          <div className="max-w-xs">
                            <p className="font-semibold">€{payment.amount.toFixed(2)}</p>
                            {payment.description && (
                              <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                                {payment.description}
                              </p>
                            )}
                          </div>
                        )}
                      </td>
                      <td className="p-4">
                        <div className="flex justify-end gap-2">
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() => editarPagamento(payment)}
                            title={t[language].edit}
                            data-testid={`edit-payment-${payment.id}`}
                          >
                            <Edit size={16} />
                          </Button>
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() => apagarPagamento(payment)}
                            className="text-red-600 hover:text-red-700"
                            title={t[language].delete}
                            data-testid={`delete-payment-${payment.id}`}
                          >
                            <Trash2 size={16} />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-8">
              <CreditCard size={48} className="mx-auto text-gray-400 dark:text-gray-500 mb-4" />
              <p className="text-gray-600 dark:text-gray-300">{t[language].noPayments}</p>
            </div>
          )}
        </CardContent>
      </Card>

      {/* Consultar despesas: aberta pelo cartao, para nao ficar enterrada
          debaixo da lista de pagamentos, que pode ter mais de mil linhas */}
      <Dialog open={despesasAbertas} onOpenChange={setDespesasAbertas}>
        <DialogContent className="max-w-3xl">
          <DialogHeader>
            <DialogTitle className="flex items-center">
              <Receipt className="mr-2" size={20} />
              {t[language].expensesList} ({despesasFiltradas.length})
            </DialogTitle>
          </DialogHeader>
          <div>

          {/* Filtros */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
            <Select value={expenseDateFilter} onValueChange={setExpenseDateFilter}>
              <SelectTrigger data-testid="expense-date-filter">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">{t[language].allDates}</SelectItem>
                <SelectItem value="today">{t[language].dayToday}</SelectItem>
                <SelectItem value="thisMonth">{t[language].thisMonth}</SelectItem>
                <SelectItem value="lastMonth">{t[language].lastMonth}</SelectItem>
                <SelectItem value="thisYear">{t[language].thisYear}</SelectItem>
                <SelectItem value="lastYear">{t[language].lastYear}</SelectItem>
                <SelectItem value="day">{t[language].pickDay}</SelectItem>
                <SelectItem value="range">{t[language].pickRange}</SelectItem>
              </SelectContent>
            </Select>

            <Select value={expenseCategoryFilter} onValueChange={setExpenseCategoryFilter}>
              <SelectTrigger data-testid="expense-category-filter">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="max-h-72">
                <SelectItem value="all">{t[language].allCategories}</SelectItem>
                {CATEGORIAS_DE_DESPESA.map((c) => (
                  <SelectItem key={c} value={c}>{nomeDaCategoria(c)}</SelectItem>
                ))}
              </SelectContent>
            </Select>

            {expenseDateFilter === 'day' && (
              <div>
                <Label htmlFor="expense-day" className="text-xs">{t[language].day}</Label>
                <Input
                  id="expense-day"
                  type="date"
                  value={expenseDay}
                  onChange={(e) => setExpenseDay(e.target.value)}
                  data-testid="expense-day"
                />
              </div>
            )}

            {expenseDateFilter === 'range' && (
              <>
                <div>
                  <Label htmlFor="expense-from" className="text-xs">{t[language].from}</Label>
                  <Input
                    id="expense-from"
                    type="date"
                    value={expenseFrom}
                    onChange={(e) => setExpenseFrom(e.target.value)}
                    data-testid="expense-from"
                  />
                </div>
                <div>
                  <Label htmlFor="expense-to" className="text-xs">{t[language].to}</Label>
                  <Input
                    id="expense-to"
                    type="date"
                    value={expenseTo}
                    onChange={(e) => setExpenseTo(e.target.value)}
                    data-testid="expense-to"
                  />
                </div>
              </>
            )}
          </div>

          {/* Lista */}
          {despesasFiltradas.length > 0 ? (
            <>
              <div className="space-y-2 max-h-96 overflow-y-auto">
                {despesasFiltradas.map((despesa) => (
                  <div
                    key={despesa.id}
                    className="flex items-start justify-between gap-3 p-3 rounded-lg"
                    style={{ background: 'var(--background-elevated)', color: 'var(--text-primary)' }}
                    data-testid={`expense-${despesa.id}`}
                  >
                    <div className="min-w-0 flex-1">
                      <p className="font-medium truncate">
                        {despesa.description || nomeDaCategoria(despesa.category)}
                      </p>
                      <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
                        {new Date(despesa.expense_date).toLocaleDateString('pt-PT')}
                        {despesa.category ? ` · ${nomeDaCategoria(despesa.category)}` : ''}
                      </p>
                    </div>
                    <div className="flex items-center gap-1 shrink-0">
                      {isAdmin() && (
                        <p className="font-semibold" style={{ color: '#dc2626' }}>
                          €{despesa.amount.toFixed(2)}
                        </p>
                      )}
                      <Button
                        type="button"
                        variant="ghost"
                        size="icon"
                        className="h-8 w-8"
                        title={t[language].editExpense}
                        onClick={() => abrirCorrecaoDaDespesa(despesa)}
                        data-testid={`edit-expense-${despesa.id}`}
                      >
                        <Edit size={15} />
                      </Button>
                      <Button
                        type="button"
                        variant="ghost"
                        size="icon"
                        className="h-8 w-8 text-red-600 hover:text-red-700"
                        title={t[language].expenseDeleted}
                        onClick={() => apagarDespesa(despesa)}
                        data-testid={`delete-expense-${despesa.id}`}
                      >
                        <Trash2 size={15} />
                      </Button>
                    </div>
                  </div>
                ))}
              </div>

              {isAdmin() && (
                <div className="flex items-center justify-between pt-3 mt-3 border-t border-gray-200 dark:border-white/10">
                  <span className="text-sm font-medium" style={{ color: 'var(--text-secondary)' }}>
                    {t[language].expensesTotal}
                  </span>
                  <span className="text-lg font-bold" style={{ color: '#dc2626' }}>
                    €{despesasFiltradas.reduce((t, d) => t + d.amount, 0).toFixed(2)}
                  </span>
                </div>
              )}
            </>
          ) : (
            <p className="text-center py-6 text-gray-500 dark:text-gray-400">{t[language].noExpenses}</p>
          )}
                  </div>
        </DialogContent>
      </Dialog>

      {/* Vendas de merchandise */}
      <Card className="card-shadow">
        <CardHeader>
          <CardTitle className="flex items-center">
            <ShoppingBag className="mr-2" size={20} />
            {t[language].recentSales} ({sales.length})
          </CardTitle>
        </CardHeader>
        <CardContent>
          {sales.length > 0 ? (
            <div className="space-y-2 max-h-80 overflow-y-auto">
              {sales.map((sale) => (
                <div
                  key={sale.id}
                  className="flex items-center justify-between p-3 rounded-lg"
                  style={{ background: 'var(--background-elevated)', color: 'var(--text-primary)' }}
                  data-testid={`sale-${sale.id}`}
                >
                  <div>
                    <p className="font-medium">
                      {sale.quantity}x {sale.item_name}
                    </p>
                    <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
                      {new Date(sale.sale_date).toLocaleDateString('pt-PT')}
                      {sale.member_name ? ` · ${sale.member_name}` : ''}
                      {sale.sold_by ? ` · vendido por ${sale.sold_by}` : ''}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="font-semibold">€{sale.total.toFixed(2)}</p>
                    <p className="text-xs" style={{ color: 'var(--text-secondary)' }}>
                      €{sale.unit_price.toFixed(2)} cada
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center py-6 text-gray-500 dark:text-gray-400">{t[language].noSales}</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default Payments;
